export default "__VITE_ASSET__Dd6I92KS__"